import React, { useEffect, useState } from 'react';
import { Card } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { datamapOverviewPath } from '@/pages/home/utils/urlConfig';
import { formatNum } from '../_config/common';
import { getDataSummary } from '@/pages/home/services/home';
import { useIntl, history } from 'umi';
import Abnormal from '@/pages/home/components/Abnormal';

export default function DataMap(props: any) {
  const { formatMessage } = useIntl(); // 中英切换方法
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [dataSum, setDataSum] = useState([0, 0]);
  const dataMapShowData = [
    {
      num: 0,
      title_intl_id: 'dbh_datasmap_games',
      icon: 'game',
    },
    {
      num: 0,
      title_intl_id: 'dbh_datasmap_companies',
      icon: 'folded-graph',
    },
  ];

  useEffect(() => {
    homePageSummary();
  }, []);

  const homePageSummary = async () => {
    setLoading(true);
    try {
      const result = await getDataSummary();
      if (result) {
        const gameTotal =
          Number(result?.mobile_games || 0) +
          Number(result?.pc_games || 0) +
          Number(result?.console_games || 0);
        const _dataSum = [gameTotal || 0, result?.companies || 0];
        setDataSum(_dataSum);
      }
      setError(false);
    } catch (err) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Card className="recent-card">
      <Card.Body
        title={
          <div className="home-table-flex" onClick={() => history.push(datamapOverviewPath)}>
            <div className="home-table-title dbh-fix-less-padding">
              {formatMessage({ id: 'dbh_datasmap' })}
            </div>
            <SvgIcon type="arrow-right" className="home-table-icon" />
          </div>
        }
      >
        <Abnormal
          isLoading={loading}
          isError={error}
          isNoData={!dataMapShowData?.length}
          style={{ height: 200 }}
          component={
            <>
              {dataMapShowData.map((e, i) => {
                return (
                  <div
                    className="recently-flex"
                    key={e?.title_intl_id}
                    onClick={() => history.push(datamapOverviewPath)}
                  >
                    <div className="recently-flex-context">
                      <SvgIcon type={e?.icon} className="recently-flex-icont" />
                      <div className="recently-flex-text">
                        <div className="recently-flex-name">
                          {formatMessage({ id: e?.title_intl_id })}
                        </div>
                        {/* <div className='recently-flex-desc'>{e?.desc}</div> */}
                      </div>
                    </div>
                    <div className="recently-flex-num">{formatNum(dataSum[i])}</div>
                  </div>
                );
              })}
            </>
          }
        />
      </Card.Body>
    </Card>
  );
}
